// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found-page_wrapper__syLOb","container":"not-found-page_container__Vvxhp","link":"not-found-page_link__S+f7I"};